module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOFtdrz+Ptgns7///+20un7Dtm1AAAACHRSTlMAYL//ACDP71kzCuAAAADjSURBVHja7dg5DsMwFANR7Y4t3f+8kaspiYAfSKM5wOvJ9JZLNSq57VJrfVSz0V+oX9Xu6hsaNaDRUq4h5VRioJJqUAc6ENHnfhwIZ04hCQhHSALCEZKAcIQkIBwkA8IRkoBwkH6CcLS0NLQdLa2pIBxCwtHQPbW0HQ09WlpTQELCEZCUcAQkJRwBSQlHQFLajoa0RBpCciEkF0JyISQXQnIhJBdCciEkF0JyISQTQoqClgnheBCOB+F4EI4H4XgQjgfheBCOAUmHzoQ40IH+BYWdLGG3T9QRFXaNRZ51u4j78Av3u1tgiT27jgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2198.png
// module id = 1320
// module chunks = 0